import { cloneDeep } from 'lodash';
import { Operator } from './operator';

export interface RequestCriteria {
  fieldName?: string;
  operator?: Operator;
  value?: string;
  // Operator.inList - lista dopuszczalnych wartości (wielokrotny wybór w filtrze kolumnowym).
  values?: any[];
  // Operator.inList - obok wartości z listy przepuszcza też wiersze bez wartości w tej kolumnie
  // (pozycja w rodzaju "Bez uchybień").
  includeEmpty?: boolean;
  start?: string;
  end?: string;
  columnFilter?: boolean;
  criteria?: RequestCriteria[];
}

export function changeCriteriaFieldName(criteria: RequestCriteria, oldField: string, newField: string): RequestCriteria {
  const newCriteria = cloneDeep(criteria);
  const x = newCriteria?.criteria.filter(cr => cr.fieldName === oldField);
  if (x?.length > 0)
    x[0].fieldName = newField;
  return newCriteria;
}

export function addOrReplaceCriteriaByName(criteria: RequestCriteria[], newCriteria: RequestCriteria): void {
  const idx = criteria.findIndex(c => c.fieldName === newCriteria.fieldName);
  if (idx !== -1)
    criteria.splice(idx, 1);
  criteria.push(newCriteria);
}

export function addOrReplaceCriteriaByNames(criteria: RequestCriteria[], newCriterias: RequestCriteria[]): void {
  newCriterias.forEach(c => {
    addOrReplaceCriteriaByName(criteria, c);
  });
}

/**
 * Column filters (columnFilter: true) are a client-side-only quick search over already-fetched
 * results, applied locally by data-util.ts's filterData(). They must never reach the backend -
 * only "real" filters set from the sidebar filter-builder belong in the REST request payload.
 */
export function excludeColumnFilterCriteria(criteria: RequestCriteria): RequestCriteria {
  if (!criteria?.criteria?.length) return criteria;
  return { ...criteria, criteria: criteria.criteria.filter(c => !c.columnFilter) };
}
